import axios from 'axios';
import config from '../../config/configureSettings';
import { constructServiceURL } from '../../core/modules/common/tools/URLTools';

export const fetchConsignment = (consignmentId) => axios.get(constructServiceURL({
  endpoint: 'fetchConsignment',
  stub: config.useStubbedEndpoints,
  params: { consignmentId },
}));
